// extracted by mini-css-extract-plugin
export default {"header":"MicrogridPowerTopoTab_header__qxXId"};